import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { selectQuotationsForCurrentBib, selectUgcSummary } from 'app/selectors/bibs/UgcSelector';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectQuotationsTransactions } from 'app/selectors/ugc/QuotationsSelector';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import BibsActions from 'app/actions/BibsActions';
import Quotations from './Quotations';

export class QuotationsContainer extends React.PureComponent {
  render() {
    return <Quotations {...this.props} />;
  }
}

QuotationsContainer.propTypes = {
  quotations: ImmutablePropTypes.list.isRequired,
  quotationsTransactions: ImmutablePropTypes.map.isRequired,
  summary: ImmutablePropTypes.map,
  bibsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  catalogBib: catalogBibShape.isRequired
};

const mapStateToProps = state => ({
  quotations: selectQuotationsForCurrentBib(state),
  quotationsTransactions: selectQuotationsTransactions(state),
  summary: selectUgcSummary(state),
  catalogBib: selectCatalogBib(state)
});

const mapDispatchToProps = dispatch => ({
  bibsActions: bindActionCreators(BibsActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(QuotationsContainer);
